import $ from 'jquery';

var selectors = Object.freeze({
	form: '.js-ajax-form',
});

var dataAttributes = Object.freeze({
	target: 'data-ajax-form-target',
	loader: 'data-ajax-form-loader',
	busy: 'data-ajax-form-busy',
});

var AjaxForm = {
	init: function () {
		AjaxForm._initEvents();
	},

	_initEvents: function () {
		$(selectors.form).on('submit', AjaxForm._handleSubmit);
	},

	_getOutputEl: function ($form) {
		var outputId = $form.attr(dataAttributes.target);
		var $output = $('#' + outputId);

		return $output;
	},

	_getLoaderEl: function ($form) {
		var loaderId = $form.attr(dataAttributes.loader);
		var $loader = $('#' + loaderId);

		return $loader;
	},

	_handleSubmit: function (e) {
		e.preventDefault();

		var $form = $(e.target).closest(selectors.form);
		var isBusy = $form.attr(dataAttributes.busy) === 'true';
		if (isBusy === false) {
			var action = $form.attr('action');
			var formData = new FormData($form[0]);

			var request = new XMLHttpRequest();

			var onSuccess = AjaxForm._handleAjaxSuccess($form);
			var onFailure = AjaxForm._handleAjaxFailure($form);

			request.addEventListener('load', onSuccess);
			request.addEventListener('error', onFailure);
			request.addEventListener('abort', onFailure);

			$form.attr(dataAttributes.busy, 'true');

			var $output = AjaxForm._getOutputEl($form);
			var $loader = AjaxForm._getLoaderEl($form);

			$output.hide();
			$loader.show();

			request.open('POST', action);
			request.send(formData);
		}
	},

	_handleAjaxSuccess: function ($form) {
		var $output = AjaxForm._getOutputEl($form);
		var $loader = AjaxForm._getLoaderEl($form);

		return function (e) {
			var request = this;

			$form.attr(dataAttributes.busy, 'false');

			$loader.hide();
			$output.html(request.response);
			$output.fadeIn();
		};
	},

	_handleAjaxFailure: function ($form) {
		var $loader = AjaxForm._getLoaderEl($form);

		return function (e) {
			var request = this;

			$form.attr(dataAttributes.busy, 'false');

			$loader.hide();
		};
	},
};

export { AjaxForm };